module.exports = __webpack_public_path__ + "static/media/details-4.80a1af72.jpeg";